import React, { Fragment } from 'react';
import { withAreaGetter } from 'providers/AreasConsumers';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { areas } from 'constants/areas';
import HeaderLinks from './header/HeaderLinks';
import Header from './header/Header';
import FinancialProductListBrowser from './FinancialProductListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_FINANCIAL_PRODUCT_WRITE, ADMIN_FINANCIAL_PRODUCT_READ } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const history = useHistoryWithContext();

  const canWrite = usePermission(ADMIN_FINANCIAL_PRODUCT_WRITE);

  const onAdd = () => {
    history.push(`/financialProducts/new`);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_FINANCIAL_PRODUCT_WRITE} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_FINANCIAL_PRODUCT_READ}>
        <FinancialProductListBrowser canWrite={canWrite} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
